import * as React from 'react';
import { DispatchWithoutAction, FC } from 'react';
import cn from 'classnames';

import { Money as MoneyType } from '../../../types';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { Money } from '../../../Money';
import Link from '../../../Link';
import { BaseButton } from '../../../BaseComponents';
import { CloseClear } from '../../../Icons';

interface Props {
	className?: string;
	contentClassName?: string;
	selected: boolean;
	price: MoneyType;
	variant: 'mostPopular' | 'regular' | 'bottomPrice';
	onClick?: () => void;
	onRemove?: DispatchWithoutAction;
	hideForAllPassengersTextBecauseSinglePassenger?: boolean; // if there single passenger in order
}

export const InsurancePrice: FC<Props> = ({
	className,
	contentClassName,
	selected,
	price,
	variant,
	onClick,
	onRemove,
	hideForAllPassengersTextBecauseSinglePassenger
}) => {
	const { t } = useTranslation('InsurancePage');
	const { InsurancePrice: theme } = useTheme('InsurancePage');

	return (
		<div
			className={cn(
				theme.wrapper,
				{
					[theme.mostPopular]: variant === 'mostPopular',
					[theme.bottomPrice]: variant === 'bottomPrice',
					[theme.forAllPassengers]: !hideForAllPassengersTextBecauseSinglePassenger
				},
				className
			)}
		>
			{variant === 'mostPopular' && (
				<div className={cn(theme.content, contentClassName)}>
					{!hideForAllPassengersTextBecauseSinglePassenger && (
						<span className={theme.light}>{t('For all passengers')}</span>
					)}

					<span className={cn(theme.bold)}>
						<Money money={price} moneyClassName={theme.bold} />
					</span>
				</div>
			)}
			{variant === 'bottomPrice' && (
				<div
					className={cn(
						theme.contentFlex,
						contentClassName,
						hideForAllPassengersTextBecauseSinglePassenger ? theme.priceOnly : null
					)}
				>
					{!hideForAllPassengersTextBecauseSinglePassenger && (
						<span className={theme.light}>{t('For all passengers')}</span>
					)}

					<span className={theme.bold}>
						<Money money={price} moneyClassName={theme.bold} />
					</span>
				</div>
			)}
			{variant === 'regular' && (
				<>
					<div className={theme.content}>
						{selected
							? onRemove && (
									<Link action={onRemove} className={cn(theme.light, theme.link)}>
										{CloseClear}
										{t('Remove')}
									</Link>
							  )
							: onClick && (
									<BaseButton variant="optionAction" className={theme.button} onClick={onClick}>
										{t('Add')}
									</BaseButton>
							  )}

						<div className={theme.price}>
							{!hideForAllPassengersTextBecauseSinglePassenger && (
								<span className={cn(theme.light, theme.label)}>{t('For all passengers')}</span>
							)}
							<Money money={price} moneyClassName={cn(theme.bold, theme.money)} />
						</div>
					</div>
				</>
			)}
		</div>
	);
};
